import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { VBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { Google, Facebook } from '../../../components/Icon';
import { FormField, FormFields } from '../../../components/FormFields';
import { Input } from '../../../components/Input';
import { register } from '../actions';
import { LOGIN_REGISTER } from '../constants';
import { selectApiKey, selectIsLoggedIn, selectWork } from '../../../modules/Api/selectors';
import { Loader } from "../../../components/Loader";
import { Well } from "../../../components/Well";
import { REQUEST_API_KEY } from '../../../modules/Api/constants';
import { PageButtons } from '../../../components/Controls/PageButtons';
import env from "../../../env";

const baseState = {
  email: '',
  password: '',
  password2: '',
};

const Container = styled.div`
  p {
    text-align:center;
  }
`;

/* eslint-disable react/prefer-stateless-function */
class RegisterComp extends BaseComponent {

  constructor(props) {
    super(props, { ...baseState });
  }

  get isValid(){
    return this.state.email.length > 3 && this.state.email.indexOf('@') > -1 && this.state.password.length >= 12 && this.state.password == this.state.password2;
  }

  fill(){
    const password= env.generatePassword();

    this.setState({
      email : env.generateEmail(),
      password, password2:password
    })
  }
  submit(){
    this.setState({error:null});
    this.props.register(this.state.email, this.state.password, this.callback( this.onRegister.bind(this)));
  }

  onRegister(result){
    if(!result.id){
      this.setState({error: result.error?.message || 'default'});
    } else {

      //login
      this.setState({success:true}, () =>  this.props.login(result.email_address, this.state.password) );

    }
  }

  render() {

    if(this.props.work) return <Loader/>

    if(this.state.success || this.props.isLoggedIn) return this.renderSuccess();

    return (
      <Container>
        <h3>{this.lbl('register.title')}<span onClick={this.fill.bind(this)}>.</span></h3>
        <VBox>
          {/* Google and Facebook can be activated after the application is available on the live server

        //https://laravel.com/docs/8.x/socialite
        //https://console.cloud.google.com/apis/credentials?project=indewal.nl-316614

        <Button icon={Google}>{this.lbl('login.google')}</Button>
        <Button icon={Facebook}>{this.lbl('login.facebook')}</Button> */}

        {
          this.state.error ? <Well alert>
          {this.lbl('register.error.' + this.state.error)}
        </Well> : null
        }

          <form>
          <FormFields>
            <FormField label={this.lbl('register.input.email')}>
              <Input
                value={this.state.email}
                name="email"
                autoComplete="email"
                onChange={this.onInputChange.bind(this)}
              />
            </FormField>

            <FormField label={this.lbl('register.input.password')} subLabel={this.lbl('register.input.password.info')}>
              <Input
                value={this.state.password}
                autoComplete="password"
                name="password"
                type="password"
                onChange={this.onInputChange.bind(this)}
              />
            </FormField>

            <FormField label={this.lbl('register.input.password2')}>
              <Input
                autoComplete="password-repeat"
                value={this.state.password2}
                name="password2"
                type="password"
                onChange={this.onInputChange.bind(this)}
              />
            </FormField>

          </FormFields>
          </form>
          <Button onClick={this.submit.bind(this)} disabled={!this.isValid} primary>{this.lbl('register.button.cta')}</Button>
        </VBox>
      </Container>
    );
  }

  renderSuccess(){
    return <Container>
      <h1>{this.lbl('register.success.title')}</h1>
      <p>{this.lbl('register.success.p1')}</p>
      <PageButtons>
        <Button onClick={this.tofn("/home")}>{this.lbl('next')}</Button>
      </PageButtons>

    </Container>
  }
}

RegisterComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({
  isLoggedIn : selectIsLoggedIn(),
  apikey : selectApiKey(),
  work : selectWork(LOGIN_REGISTER)
});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,

    register(email,password,callback) {
      dispatch(register(email,password,callback));
    },
    login(email,password){

      dispatch({
        type : REQUEST_API_KEY,
        email,password
      });
    }

  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const Register = compose(
  withRouter,
  withConnect,
  injectIntl,
)(RegisterComp);
